import React from "react";
import { render } from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import "./circleButton.css";
import "./whiteFlash.css";
import "./camera.css";
import queryString from "query-string";
import C from "./constants";
import logs from "./helpers/logs";

window.React = React;
window.store = store;

logs.initialize();

// parse the reference id from the url
let urlParts = queryString.parseUrl(window.location.href);
if ("r" in urlParts.query) {
    // reference id of questionset
    store.dispatch({ type: C.CAPTURE_REF_ID, referenceId: urlParts.query.r });
}
if ("rq" in urlParts.query) {
    // request id
    store.dispatch({ type: C.CAPTURE_REQUEST_ID, requestId: urlParts.query.rq });
}
if ("c" in urlParts.query) {
    // access code
    store.dispatch({ type: C.CAPTURE_ACCESS_CODE, accessCode: urlParts.query.c });
}
if ("o" in urlParts.query) {
    // organization identifier (only used when only reference id is passed in)
    store.dispatch({ type: C.CAPTURE_ORGANIZATION, organization: urlParts.query.o });
}

render(
    <Provider store={store}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <App store={store}/>
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);
